import staticEnumsSaga from './staticEnumsSaga'
import editSaga from './editSaga'
import createSaga from './createSaga'
import oneBadgeSaga from './oneBadge'
import listSaga from './listSaga'

const badgesSagas = [staticEnumsSaga(), editSaga(), createSaga(), oneBadgeSaga(), listSaga()]

export default badgesSagas
